import React, { useCallback, useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { scrollIntoViewWithHeader } from '../../../../utils/scrollIntoViewWithHeader';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Button from '../../../../Button';
import {
  HEADER_HEIGHT_TO_SKIP_WHEN_SCROLLING,
  PX_SCROLLED_BEFORE_SHOWING_SCROLL_TO_NEXT,
} from '../../constants';

import s from './ScrollToNextPostButton.scss';

export interface Props {
  className?: string;
  buttonClassName?: string;
  isDisplayed?: boolean;
  scrollTarget?: React.RefObject<HTMLElement | null>;
  biData?: BiEvent;
  extraYWhenScrolling?: number;
  pxScrolledBeforeShowing?: number;
}

const ScrollToNextPostButton: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  buttonClassName,
  isDisplayed,
  scrollTarget,
  biData,
  extraYWhenScrolling = HEADER_HEIGHT_TO_SKIP_WHEN_SCROLLING,
  pxScrolledBeforeShowing = PX_SCROLLED_BEFORE_SHOWING_SCROLL_TO_NEXT,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  const scrollToTarget = useCallback(() => {
    const scrollTargetNode = (scrollTarget as any).current;
    scrollTargetNode &&
      scrollIntoViewWithHeader(
        scrollTargetNode,
        isMobile,
        extraYWhenScrolling,
        undefined,
        true,
        true
      );
  }, [scrollTarget, isMobile, extraYWhenScrolling]);

  return isDisplayed ? (
    <div
      className={classnames(s['scroll-to-next-container'], className)}
      style={{ top: pxScrolledBeforeShowing }}
    >
      <Button
        view="b19"
        className={classnames(s['scroll-to-next-btn'], buttonClassName)}
        onClick={scrollToTarget}
        biData={biData}
      >
        <ArrowDown className={s['scroll-to-next-btn-icon']} size={IconSize.SMALL} />
        {t('deviationview.journal.skipToNextButton')}
      </Button>
    </div>
  ) : null;
};
ScrollToNextPostButton.displayName = 'ScrollToNextPostButton';

export default ScrollToNextPostButton;
